(function () {
  function parsePrice(text) {
    return parseInt(text.replace(/[^0-9]/g, ''), 10) || 0;
  }

  // PDP usa .hdt-price__sale; cards usan .hdt-price__list directamente
  function getPriceList(wrapper) {
    return wrapper.querySelector('.hdt-price__sale') || wrapper.querySelector('.hdt-price__list');
  }

  function applyLayout(wrapper) {
    var priceList = getPriceList(wrapper);
    if (!priceList) return;

    var compareHost    = priceList.querySelector('hdt-compare-at-price');
    var priceHost      = priceList.querySelector('hdt-price');
    if (!priceHost) return;

    var compareMoneyEl = compareHost && compareHost.querySelector('.hdt-money');
    var priceMoneyEl   = priceHost.querySelector('.hdt-money');
    var isOnSale       = compareHost && !compareHost.hidden && compareMoneyEl;

    if (priceMoneyEl) {
      if (isOnSale) {
        priceMoneyEl.style.setProperty('color', '#A92717', 'important');
        priceMoneyEl.style.setProperty('font-weight', '700', 'important');
      } else {
        priceMoneyEl.style.removeProperty('color');
        priceMoneyEl.style.removeProperty('font-weight');
      }
    }

    var compareRow = priceList.querySelector('.mox-compare-row');

    if (!isOnSale) {
      if (compareRow) compareRow.style.display = 'none';
      return;
    }

    if (compareMoneyEl) {
      compareMoneyEl.style.setProperty('font-weight', '400', 'important');
      compareMoneyEl.style.setProperty('font-size', '14px', 'important');
    }

    var isPDP = !!wrapper.querySelector('.hdt-price__sale');

    priceList.style.display    = 'flex';
    priceList.style.flexWrap   = 'wrap';
    priceList.style.alignItems = 'center';
    // PDP: sin row-gap para acercar las dos filas; PLP: 4px entre items
    priceList.style.gap        = isPDP ? '0 4px' : '4px';
    priceHost.style.order      = '1';
    priceHost.style.marginBottom = isPDP ? '0' : '';

    if (!compareRow) {
      compareRow = document.createElement('div');
      compareRow.className = 'mox-compare-row';
      priceList.appendChild(compareRow);
    }
    compareRow.setAttribute('style', 'flex-basis:100%;width:100%;display:flex;align-items:center;gap:4px;order:2;margin-top:' + (isPDP ? '-6px' : '0') + ';');

    if (compareHost.parentNode !== compareRow) {
      compareRow.insertBefore(compareHost, compareRow.firstChild);
    }

    var pctSpan = compareRow.querySelector('.mox-sale-pct');
    if (!pctSpan) {
      pctSpan = document.createElement('span');
      pctSpan.className = 'mox-sale-pct';
      compareRow.appendChild(pctSpan);
    }
    pctSpan.style.cssText = 'color:#A92717;font-weight:400;font-size:13px;white-space:nowrap;';

    var compareAt = parsePrice(compareMoneyEl.textContent);
    var price     = parsePrice(priceMoneyEl ? priceMoneyEl.textContent : '0');

    if (compareAt > price && compareAt > 0) {
      var pct = Math.max(1, Math.round((compareAt - price) * 100 / compareAt));
      pctSpan.textContent = '-' + pct + '%';
    } else {
      pctSpan.textContent = '';
    }
  }

  var observed = new WeakMap();

  function makeObserver(target, getWrapper) {
    if (observed.has(target)) return;
    observed.set(target, true);

    var applying = false;
    var pending  = false;

    function run() {
      pending  = false;
      applying = true;
      var w = typeof getWrapper === 'function' ? getWrapper() : getWrapper;
      if (w) applyLayout(w);
      applying = false;
    }

    new MutationObserver(function () {
      if (applying || pending) return;
      pending = true;
      requestAnimationFrame(run);
    }).observe(target, { subtree: true, childList: true, characterData: true, attributes: true });

    run();
  }

  // Tarjetas PLP: observar al nivel de la card
  function observeCard(card) {
    makeObserver(card, function () {
      return card.querySelector('.hdt-price-wrapp');
    });
  }

  // PDP y quick-view: observar el wrapper de precio directamente
  function observeWrapper(wrapper) {
    makeObserver(wrapper, wrapper);
  }

  function init() {
    // PLP — tarjetas
    document.querySelectorAll('hdt-card-product, .hdt-card-product').forEach(observeCard);

    // PDP / featured product / quick-view — wrappers fuera de una card
    document.querySelectorAll('.hdt-price-wrapp').forEach(function (wrapper) {
      if (!wrapper.closest('hdt-card-product, .hdt-card-product')) {
        observeWrapper(wrapper);
      }
    });

    // Elementos añadidos dinámicamente (quick-view, secciones lazy, etc.)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          node.querySelectorAll('hdt-card-product, .hdt-card-product').forEach(observeCard);
          if (node.matches && node.matches('hdt-card-product, .hdt-card-product')) observeCard(node);

          node.querySelectorAll('.hdt-price-wrapp').forEach(function (wrapper) {
            if (!wrapper.closest('hdt-card-product, .hdt-card-product')) observeWrapper(wrapper);
          });
          if (node.matches && node.matches('.hdt-price-wrapp') && !node.closest('hdt-card-product, .hdt-card-product')) {
            observeWrapper(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
